import React from 'react';

import useTitle from 'src/hooks/useTitle';
import MultipleQuotesContainer from 'src/containers/MultipleQuotes';
import { t } from 'src/libs/i18n';

const MultipleQuotesPage: React.FC = () => {
  useTitle(t('multiple_quotes_page.title'));
  return <MultipleQuotesContainer />;
};

export const PATH = '/multiple-quotes' as const;
export default MultipleQuotesPage;
